import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
    html {
        --font: 'LKSans';
        --font-bold: 'LKSansBold';
        --header-color: #363636;
        --bg-color-text: linear-gradient(45deg, #f2a084 0%, #f6c6c7 100%);
        --bg-color: #1e285b;
        --bg-shadow-color: linear-gradient(180deg, rgba(57, 0, 47, 0) 0%, #153882 100%);
        --form-bg-color: rgba(0, 0, 0, 0.3);
        --btn-color: #FFB400;
        --btn-color-disabled: #C2C2C2;
        --border-color: #979797;
        --text-color: #3C3C3C;
        --text-color-disabled: #818181;
        --text-info-color: #DDDDDD;
        --text-white-color: #ffffff;
        --placeholder-color:  #dedede;
        --dimmer-yellow:#E9AE15;
        --brighter-yellow: #FFC20E;

        // border radius
        --border-radius-xs: 0.219rem;
        --border-radius-sm: 0.5rem;
        --border-radius-lg: 1.313rem;

        // Font Weight
        --fw-sm: 400;
        --fw-md: 500;
        --fw-lg: 600;
        --fw-xl: 800;

        //Transform
        --left-50: 50%;
        --top-50: 50%;
        --transform-center: translate(-50%, -50%);

        //Colors
        --white: #ffffff;
        --blackcurrant: #37183f;

        //width by percentage
        --w-10 : 100%;
        --w-8: 80%;
        --w-5: 50%;
    }

    body[data-device='mobile'] {
        --label-spacing: 0.8em;


        // Font Size
        --fs-xxs: 0.75rem; 
        --fs-xs: 0.875rem;
        --fs-sm: 1rem;
        --fs-md: 1.125rem;
        --fs-lg: 1.25rem;
        --fs-xl: 1.375;
        --fs-xxl: 1.5rem;
        --fs-xxxl: 1.875rem;

        
        // Item Height
        --it-hg-sm: 24px;
        --it-hg-md: 32px;
        --it-hg-lg: 40px;
        --it-hg-xl: 60px;
        --it-hg-xxl: 74px;
        
        // Element Height
        --el-hg-sm: 120px;
        --el-hg-md: 150px;
        --el-hg-lg: 420px;

        
        // Margin
        --mg-xxs: 5px;
        --mg-xs: 15px;
        --mg-sm: 20px;
        --mg-md: 25px;
        --mg-lg: 46px;

        // Padding
        --pd-xs: 5px;
        --pd-sm: 10px;

        //widths
        --width-sm: 20em;
        --width-md: 22em;

    }

    body[data-device='tab'] {
        --label-spacing: 0.5em;

        // Font Size
        --fs-xxs: 1rem;
        --fs-xs: 1.125rem;
        --fs-sm: 1.25rem;
        --fs-md: 1.375;
        --fs-lg: 1.5rem;
        --fs-xl:  1.875rem;
        --fs-xxl: 2rem;
        --fs-xxxl: 2.125rem;


        // Item Height
        --it-hg-sm: 24px;
        --it-hg-md: 40px;
        --it-hg-lg: 40px;
        --it-hg-xl: 60px;
        --it-hg-xxl: 74px;

        // Element Height
        --el-hg-sm: 220px;
        --el-hg-md: 150px;
        --el-hg-lg: 470px;


        // Margin
        --mg-xxs: 15px;
        --mg-xs: 35px;
        --mg-sm: 40px;
        --mg-md: 45px;
        --mg-lg: 66px;

        // Padding
        --pd-xs: 10px;
        --pd-sm: 20px;

        //widths
        --width-sm: 25em;
        --width-md: 35em;

    }

    body[data-device='desktop'] {
        --label-spacing: 0.5em;
        // Font Size
        --fs-xxs: 1rem;
        --fs-xs: 1.125rem;
        --fs-sm: 1.25rem;
        --fs-md: 1.375;
        --fs-lg: 1.5rem;
        --fs-xl:  1.875rem;
        --fs-xxl: 2rem;
        --fs-xxxl: 2.125rem;


        // Item Height
        --it-hg-sm: 24px;
        --it-hg-md: 40px;
        --it-hg-lg: 40px;
        --it-hg-xl: 60px;
        --it-hg-xxl: 74px;

        // Element Height
        --el-hg-sm: 220px;
        --el-hg-md: 150px;
        --el-hg-lg: 470px;


        // Margin
        --mg-xxs: 15px;
        --mg-xs: 35px;
        --mg-sm: 40px;
        --mg-md: 45px;
        --mg-lg: 66px;

        //widths
        --width-sm: 25em;
        --width-md: 35em;

        // Padding
        --pd-xs: 10px;
        --pd-sm: 20px;

    }

    body {
        margin: 0;
        padding: 0;
		font-family: var(--font);
        background: var(--bg-color);
        /* margin-bottom: 20px; */

        // To hide up and down arrow for number input 
        input[type=number] {
            -moz-appearance:textfield;
        }

        overscroll-behavior: none;
    }
`

export default GlobalStyles
